module.exports = __webpack_public_path__ + "img/logoPython.593f7433.svg";